export const PayTypeEnum = {
  P2P: 'p2p',
};

export const PayType = [
  {code: 'remit', name: '银行卡转账'},
  {code: 'alipay', name: '支付宝'},
  {code: 'online_transfer', name: '快捷支付'},
  {code: 'remit_qr', name: 'QR 银行卡转账'},
  {code: 'p2p', name: 'P2P'},
  {code: 'momopay', name: 'MOMOPAY'},
  {code: 'zalopay', name: 'ZALOPAY'},
  {code: 'va_offline', name: 'VA Offline'},
  {code: 'ovo_wallet', name: 'OVO Wallet'},
  {code: 'gopay', name: 'GOPAY'},
  {code: 'dana', name: 'DANA'},
  {code: 'upi', name: 'UPI'},
  {code: 'netbanking', name: 'NETBANKING'},
  {code: 'remit_idr_low_amt', name: 'REMIT_IDR_LOW_AMT'},
  {code: 'remit_thb_low_amt', name: 'REMIT_THB_LOW_AMT'},
  {code: 'remit_qr_thb_low_amt', name: 'REMIT_QR_THB_LOW_AMT'},
  {code: 'thai_qr_cor', name: 'THAI_QR_COR'},
  {code: 'remit_qr_thb_low_amt_2', name: 'REMIT_QR_THB_LOW_AMT_2'},
  {code: 'true_money', name: 'TRUE_MONEY'},
  {code: 'remit_qr_idr_low_amt', name: 'REMIT_QR_IDR_LOW_AMT'},
  {code: 'remit_thb_low_amt_fafapay', name: 'REMIT_THB_LOW_AMT_FAFAPAY'},
  {code: 'remit_qr_thb_low_amt_fafapay', name: 'REMIT_QR_THB_LOW_AMT_FAFAPAY'},
  {code: 'remit_vnd_low_amt_fafapay', name: 'REMIT_VND_LOW_AMT_FAFAPAY'},
  {code: 'remit_qr_vnd_low_amt_fafapay', name: 'REMIT_QR_VND_LOW_AMT_FAFAPAY'},
  {code: 'remit_vnd_low_amt_smart', name: 'REMIT_VND_LOW_AMT_SMART'},
  {code: 'remit_qr_vnd_low_amt_smart', name: 'REMIT_QR_VND_LOW_AMT_SMART'},
  {code: 'momopay_smart', name: 'MOMOPAY_SMART'},
  {code: 'zalopay_smart', name: 'ZALOPAY_SMART'},
  {code: 'remit_qr_thb_low_amt_speed', name: 'REMIT_QR_THB_LOW_AMT_SPEED'},
  {code: 'true_money_speed', name: 'TRUE_MONEY_SPEED'},
];
